import { PipeTransform, Pipe } from '@angular/core';
import { enumToList } from '../enum-to-list';
import { IdName } from '../../models/id-name.model';
import { IncidentsSupport } from './../../enums/incidents-support.enum';

@Pipe({
  name: 'incidentsSupport',
  standalone: false
})
export class IncidentsSupportPipe implements PipeTransform {
  public transform(value: IncidentsSupport): string {
    return getIncidentsSupport(value);
  }
}

export function getIncidentsSupport(value: IncidentsSupport): string {
  switch (value) {
    case IncidentsSupport.None:
      return 'None';
    case IncidentsSupport.Summary:
      return 'Summary';
    case IncidentsSupport.Collecting:
      return 'Collecting';
    default:
      throw new Error(`Unsupported value for IncidentsSupport: ${value}.`);
  }
}

export function getIncidentsSupportList(): IdName[] {
  return enumToList(IncidentsSupport, getIncidentsSupport);
}
